import {FETCH_SOURCES,FETCH_MYTHSANDFACTS,FETCH_GAMECUSTOMCONFIG} from './typs';
import axios from 'axios';

export function getSources(lang){
    return function(dispatch){
    axios.get('data_'+lang+'/sources.json')
    .then(response => {
        dispatch({
            type:FETCH_SOURCES,
            sources:response.data
        });
    });
}
}

export function getMythsAndFacts(lang){
    return function(dispatch){
    axios.get('game-skins/build-rev23-3HSR1vhO1/data_'+lang+'/myths_facts.json')
    .then(response => {
        dispatch({
            type:FETCH_MYTHSANDFACTS,
            mythsAndFacts:response.data
        });
    });
}
}


export function getGameCustomConfig(lang){
    console.log(lang)
    return function(dispatch){
    axios.get('game-skins/build-rev23-3HSR1vhO1/data_'+lang+'/game_custom_config.json')
    .then(response => {
        console.log(response)
        dispatch({
            type:FETCH_GAMECUSTOMCONFIG,
            gameCustomConfig:response.data
        });
    });
}
}



// WEBPACK FOOTER //
// ./src/actions/localActions.js